import { useCallback } from 'react';
import { DropdownItem } from 'reactstrap';
import { useQuery } from '@tanstack/react-query';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLanguage } from '@fortawesome/free-solid-svg-icons';
import i18n, { LANGUAGE_LABELS } from '@s20/i18n';
import { useDispatch, useSelector } from '@s20/hooks/redux.hooks';
import { setPreferredLanguage } from '@s20/slices/features/common.slice';
import { getPreferredLanguageCode } from '@s20/selectors/features/common.selectors';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes } from '../Common';
import ValidatedSelect from '../common/forms/ValidatedSelect';
import { Modal } from '../common/Modal';
import { toasty } from '../common/forms/FormElements';

/**
 * TODO: There are various localization issues present in the app for non-flaggers
 * Until such a time that we're satisfied with the spanish-language version of the app,
 * The preferred language can only be set from the employee profile
 */
export const ChangeLanguage = () => {
    const dispatch = useDispatch();
    const userLanguage = useSelector(getPreferredLanguageCode);

    const { data: availableLanguages, isLoading } = useQuery({
        queryKey: ['tenantLanguages'],
        queryFn: () => httpClient.js(ApiRoutes.language.tenant()),
    });

    const handleChangeLanguageButtonClick = useCallback(() => {
        const currentUserLanguage = (availableLanguages || []).find((lang) => lang.name === userLanguage)?.id;

        Modal.show({
            title: i18n.t('nav:changeLanguage'),
            initialValues: {
                languageId: currentUserLanguage,
            },
            body: () => (
                <ValidatedSelect
                    name="languageId"
                    isLoading={isLoading}
                    label={i18n.t('employee:preferredLanguage')}
                    options={availableLanguages.map((language) => ({ value: language.id, label: LANGUAGE_LABELS[language.name] }))}
                    required
                    hideClear
                />
            ),
            onSubmit: async ({ languageId }) => {
                try {
                    const language = availableLanguages.find((language) => language.id === languageId);

                    await httpClient.put(ApiRoutes.language.me(), { languageId });
                    dispatch(setPreferredLanguage(language.name));

                    toasty.success(i18n.t('employee:preferredLanguageSaved'));
                } catch (e) {
                    console.error(e);
                    toasty.error(i18n.t('employee:preferredLanguageSaveError'));
                }
            },
        });
    }, [availableLanguages, isLoading, dispatch, userLanguage]);

    if (isLoading || (availableLanguages || []).length <= 1) {
        return null;
    }

    return null;

    return (
        <DropdownItem onClick={handleChangeLanguageButtonClick}>
            <FontAwesomeIcon
                icon={faLanguage}
            />

            {i18n.t('nav:changeLanguage')}
        </DropdownItem>
    );
};